import React from 'react';
import './AuthPrompt.css';

export default function SignupError() {
  return (
    <div className="auth-container">
      <h2>Confirmation Error</h2>
      <p>There was a problem confirming your email.</p>
      <button 
        className="auth-option"
        onClick={() => window.location.href = '/signup'}
      >
        Try Again
      </button>
    </div>
  );
}